import { thumbEmbroideryLeftThrow } from 'src/features/atoms/glove/drawer/common/back/embroidery'
import { Embroidery } from 'src/types'
import { notThumbEmbroideryLeftThrow } from 'src/util/canvas'

export const fingerEmbroideryDrawerLeftThrow = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  // 親指への刺繍
  const isEmbroideryOfThumb = embroideries.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryOfThumb) {
    thumbEmbroideryLeftThrow(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      0,
      40,
      -5
    )
  }
  // 小指への刺繍
  const isEmbroideryOfChild = embroideries.some((x) => x.position.value === 'childFinger')
  if (isEmbroideryOfChild) {
    notThumbEmbroideryLeftThrow(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'childFinger'),
      -20,
      50,
      3
    )
  }
}
